const jumpMenu = document.getElementById('directory_jump_menu');

const init = function() {
  if ( jumpMenu ) {
    jumpMenu.addEventListener( 'change', ( event ) => {
      const jumpTo = jumpMenu.options[jumpMenu.selectedIndex].value;
      if ( jumpTo ) {
        location.hash = "#"+jumpTo;
      }
    } );
  }
};

const api = {
	init: init
};

export default api;